import * as actions from './actions';

export default {
  connect: actions.openFrame,
  logOut: actions.logOut,
};